import react from "react";

import cp1 from "../images/commercials/CP Company Teens/C.P. COMPANY_001 Large.jpeg";
import cp2 from "../images/commercials/CP Company Teens/C.P. COMPANY_002 Large.jpeg";
import cp3 from "../images/commercials/CP Company Teens/C.P. COMPANY_003 Large.jpeg";
import cp4 from "../images/commercials/CP Company Teens/C.P. COMPANY_004 Large.jpeg";
import cp5 from "../images/commercials/CP Company Teens/C.P. COMPANY_005 Large.jpeg";
import cp6 from "../images/commercials/CP Company Teens/C.P. COMPANY_006 Large.jpeg";
import cp8 from "../images/commercials/CP Company Teens/C.P. COMPANY_008 Large.jpeg";
import cp9 from "../images/commercials/CP Company Teens/C.P. COMPANY_009 Large.jpeg";
import cp10 from "../images/commercials/CP Company Teens/C.P. COMPANY_010 Large.jpeg";
import cp11 from "../images/commercials/CP Company Teens/C.P. COMPANY_011 Large.jpeg";
import cp12 from "../images/commercials/CP Company Teens/C.P. COMPANY_012 Large.jpeg";
import cp13 from "../images/commercials/CP Company Teens/C.P. COMPANY_013 Large.jpeg";
import cp15 from "../images/commercials/CP Company Teens/C.P. COMPANY_015 Large.jpeg";
import cp16 from "../images/commercials/CP Company Teens/C.P. COMPANY_016 Large.jpeg";
import cp17 from "../images/commercials/CP Company Teens/C.P. COMPANY_017 Large.jpeg";
import cp18 from "../images/commercials/CP Company Teens/C.P. COMPANY_018 Large.jpeg";
import cp19 from "../images/commercials/CP Company Teens/C.P. COMPANY_019 Large.jpeg";
import cp20 from "../images/commercials/CP Company Teens/C.P. COMPANY_020 Large.jpeg";
import cp21 from "../images/commercials/CP Company Teens/C.P. COMPANY_021 Large.jpeg";


const CPCompanyTeens = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={cp1} alt="CP Company Teens Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={cp2} alt="CP Company Teens Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={cp3} alt="CP Company Teens Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={cp4} alt="CP Company Teens Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={cp5} alt="CP Company Teens Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={cp6} alt="CP Company Teens Commercial Photography - Image 6"/>
                </div>
                
                <div className="single portrait">
                    <img src={cp8} alt="CP Company Teens Commercial Photography - Image 8"/>
                </div>
                 <div className="single portrait">
                    <img src={cp9} alt="CP Company Teens Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={cp10} alt="CP Company Teens Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={cp11} alt="CP Company Teens Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={cp12} alt="CP Company Teens Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={cp13} alt="CP Company Teens Commercial Photography - Image 13"/>
                </div>
                
                <div className="single portrait">
                    <img src={cp15} alt="CP Company Teens Commercial Photography - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={cp16} alt="CP Company Teens Commercial Photography - Image 16"/>
                </div>
                <div className="single portrait">
                    <img src={cp17} alt="CP Company Teens Commercial Photography - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={cp18} alt="CP Company Teens Commercial Photography - Image 18"/>
                </div>
                 <div className="single portrait">
                    <img src={cp19} alt="CP Company Teens Commercial Photography - Image 19"/>
                </div>
                <div className="single portrait">
                    <img src={cp20} alt="CP Company Teens Commercial Photography - Image 20"/>
                </div>
                <div className="single portrait">
                    <img src={cp21} alt="CP Company Teens Commercial Photography - Image 21"/>
                </div>
            </div>
        </div>
    );
}

export default CPCompanyTeens;